var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbmDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ibm-3{fill:#8cd211}.ibm-3,.cls-3,.cls-4{fill-rule:evenodd}.cls-3{fill:#20343e}.cls-4{fill:#5aaafa}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_ibm_cloud",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M25.9 21.072l-10.086 5.283V15.9L25.9 10.564z",
    className: "ibm-3",
    transform: "translate(17.055 15.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M14.84 26.325l-9.284-4.848V11.018l9.284 4.848z",
    className: "cls-3",
    transform: "translate(16.371 15.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M30.786 8.1l-9.769-5.068-3.25 1.668 9.553 4.964V27.4l3.466-1.783z",
    className: "cls-4",
    transform: "translate(17.184 15.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M26.954 22.252l-10.888 5.713L.054 19.61 0 24.567l15.958 8.246 11-5.659z",
    className: "ibm-3",
    transform: "translate(16 16.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M20.388 2.315L15.958 0 .054 8.3 0 19.14l4.322 2.207V10.725z",
    className: "cls-3",
    transform: "translate(16 14.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M15.592 14.895L7.1 10.47l9.661-5.012L25.2 9.877z",
    className: "cls-4",
    transform: "translate(16.473 15.297)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmDefault);
export default __webpack_public_path__ + "static/media/ibm-default.bd1210649ffec06f83965fefd0cf9ef2.svg";
export { ForwardRef as ReactComponent };